module.exports = __webpack_public_path__ + "media/images/picto-pionnier-87121ea261e5cf5fee834c818c201f88.png";